import WorkflowBoard from "@/components/workflow/WorkflowBoard";
import OpsWorkflowNav from "@/components/workflow/OpsWorkflowNav";

export default function ClientWorkflow() {
  return (
    <div className="flex flex-col h-full">
      <OpsWorkflowNav />
      <div className="flex-1 min-h-0">
        <WorkflowBoard boardKey="client" title="Client Workflow" classicPath="/client-success/classic" workspacePathFn={(id) => `/client-workspace/${id}`} />
      </div>
    </div>
  );
}
